import { render, staticRenderFns } from "./answerInterAnalysis.vue?vue&type=template&id=c866705a&scoped=true"
import script from "./answerInterAnalysis.vue?vue&type=script&lang=js"
export * from "./answerInterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./answerInterAnalysis.vue?vue&type=style&index=0&id=c866705a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c866705a",
  null
  
)

export default component.exports